import Spacing from "@irati/ui/src/Spacing"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"

export const Disclaimer = () => {
  return (
    <Spacing marginTop={6} marginBottom={5}>
      <Body large maxWidth="unset">
        <FormattedMessage id="platform.payrollpay.store.landing.c2w.disclaimer" />
      </Body>
    </Spacing>
  )
}
